import { render, staticRenderFns } from "./ShareDialogNote.vue?vue&type=template&id=493502f3"
import script from "./ShareDialogNote.vue?vue&type=script&lang=js"
export * from "./ShareDialogNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports